<template>
    <div class="page-head">
        <div class="container">
            <div class="row">
                <div class="page-head-content">
                    <h1 class="page-title">Search Agencies</h1>
                </div>
            </div>
        </div>
    </div>

    <div class="properties-area recent-property" style="background-color: #FFF;">
        <div class="container">
            <div class="row">

                <div class="col-md-9  pr0 padding-top-40 agencies-page">
                    <div class="col-md-12 clear">
                        <div class="row">
                            <div class="col-md-6">
                                <form @submit.prevent="handleSubmit">
                                    <input type="text" class="form-control" name="keyword" placeholder="Enter Search Key word" v-model="searchParams.agency_name" />
                                </form>
                            </div>
                            <div class="col-md-6 items-per-page-container">
                                <div class="items-per-page">
                                    <label for="items_per_page"><b>Items per page :</b></label>
                                    <div class="sel">
                                        <select id="items_per_page" name="per_page" @change="handlePerPage">
                                            <option v-for="page of pagesList" :key="page" :value="page" :selected="page === searchParams.paging.per_page">{{page}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 clear">
                        <div class="fa-3x" v-if="loading">
                            <i class="fa fa-spinner fa-spin"></i>
                        </div>

                        <div id="list-type" class="proerty-th-list" v-if="!loading && agencies && agencies.data && agencies.data.length > 0">
                            <div class="col-sm-6 col-md-4 p0" v-for="agency of agencies.data" :key="agency.id">
                                <AgencyTemplate :agency="agency" />
                            </div>
                        </div>

                        <div v-else class="proerty-th-list">
                            <p class="text-center" style="margin-top: 10px">No agencies match your search</p>
                        </div>
                    </div>

                    <div class="col-md-12" v-if="!loading && agencies && agencies.data && agencies.data.length > 0">
                        <div class="pull-right">
                            <Pagination :item="agencies" @onPaginate="handlePaginate" />
                        </div>
                    </div>
                 </div>

            </div>
        </div>
    </div>
</template>

<script>
import {ref} from "vue";
import AgencyTemplate from "../partials/AgencyTemplate";
import Pagination from "../partials/Pagination";
import {useRoute, useRouter} from "vue-router";

export default {
    name: "Agencies",
    components: {Pagination, AgencyTemplate},
    data() {
      return {
          pagesList: [6, 9, 12, 15, 20, 30, 45, 60]
      }
    },
    setup() {
        const route = useRoute();
        const router = useRouter();

        const agencies = ref(null);
        const loading = ref(false);
        const searchParams = ref({paging: {per_page: 20, page: 1}, agency_name: ''});

        const getSearchParams = () => {
            const params = [];
            const paramsObj = {};

            if(searchParams.value.paging.page > 1) {
                params.push(`page=${searchParams.value.paging.page}`);
                paramsObj.page = searchParams.value.paging.page;
            }

            if(searchParams.value.paging.per_page !== 20) {
                params.push(`per_page=${searchParams.value.paging.per_page}`);
                paramsObj.per_page = searchParams.value.paging.per_page;
            }

            if(searchParams.value.agency_name) {
                params.push(`agency_name=${searchParams.value.agency_name}`);
                paramsObj.agency_name = searchParams.value.agency_name;
            }

            return [params, paramsObj];
        }

        const searchAgencies = () => {
            loading.value = true;

            const params = getSearchParams();

            updateUrlQueryParams(params[1]);

            window.axios.get('/api/agency' + (params[0].length > 0 ? `?${params[0].join('&')}` : '')).then(response => {
                loading.value = false;
                agencies.value = response.data.agencies;
            }).catch(err => {
                loading.value = false;
            });
        }

        const handlePaginate = (page) => {
            searchParams.value.paging.page = page;

            searchAgencies();
        }

        const handlePerPage = (ev) => {
            const perPage = parseInt(ev.target.value);

            searchParams.value.paging.per_page = perPage;

            searchAgencies();
        }

        const handleSubmit = () => {
            searchParams.value.paging.page = 1;

            searchAgencies();
        }

        const updateUrlQueryParams = (params) => {
            let query = Object.assign({}, route.query);

            if(Object.entries(params).length) {
                query = {...params};
                router.replace({query});
            } else {
                router.replace({});
            }
        }

        searchAgencies();

        return {
            agencies,
            loading,
            handlePaginate,
            handlePerPage,
            handleSubmit,
            searchParams
        }
    }
}
</script>

<style scoped>
    .items-per-page-container {
        display: flex;
        justify-content: flex-end;
    }

    .items-per-page-container label, .items-per-page-container .sel {
        display: inline;
    }

    .items-per-page-container .sel {
        margin: 5px;
    }
</style>
